import React from "react";
import { Box } from "@chakra-ui/react";
import {
  HOME_PAGE_CONTAINER_PROPS,
  HOME_PAGE_PY,
  HomePageSection,
  HomePageSectionHeading,
} from "./HomePage";
import { HomePageSoloFeatured } from "./HomePageSoloFeatured";
import { HomePageTutorialGrid } from "./HomePageTutorialGrid";
import { graphql, useStaticQuery } from "gatsby";

export function HomePageIntroTutorials() {
  const data = useStaticQuery<Queries.ListHomeTutorialsQuery>(graphql`
    query ListHomeTutorials {
      liftOff: allCourse(filter: { courseId: { eq: "lift-off-part1/v2" } }) {
        nodes {
          ...HomePageTutorial
        }
      }
      liftOff2: allCourse(filter: { courseId: { eq: "lift-off-part2/v2" } }) {
        nodes {
          ...HomePageTutorial
        }
      }
      liftOff3: allCourse(filter: { courseId: { eq: "lift-off-part3/v2" } }) {
        nodes {
          ...HomePageTutorial
        }
      }
      introDGS: allCourse(filter: { slug: { eq: "intro-dgs" } }) {
        nodes {
          ...HomePageTutorial
        }
      }
      introHC: allCourse(filter: { slug: { eq: "intro-hotchocolate" } }) {
        nodes {
          ...HomePageTutorial
        }
      }
      introTS: allCourse(filter: { slug: { eq: "intro-typescript" } }) {
        nodes {
          ...HomePageTutorial
        }
      }
      introStrawberry: allCourse(filter: { slug: { eq: "intro-strawberry" } }) {
        nodes {
          ...HomePageTutorial
        }
      }
      voyage: allCourse(filter: { slug: { eq: "voyage-part1" } }) {
        nodes {
          ...HomePageTutorial
        }
      }
      fedCourses: allCourse(
        filter: {
          slug: {
            in: [
              "federation-dgs"
              "federation-hotchocolate"
              "federation-typescript"
            ]
          }
        }
      ) {
        nodes {
          ...HomePageTutorial
        }
      }
    }
  `);

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        mx="4"
        mt={{ base: "8", lg: "16" }}
      >
        <Box
          maxW={{ base: "full", lg: "container.lg" }}
          border="1px"
          borderColor="blue.400"
          borderRadius="2xl"
          bg="silver.200"
          w={{ base: "full", lg: "container.lg" }}
          padding={{ base: "4", md: "8", lg: "8" }}
          _dark={{
            bg: "black.200",
            borderColor: "indigo.400",
          }}
        >
          <HomePageSoloFeatured />
        </Box>
      </Box>
      <HomePageSection {...HOME_PAGE_CONTAINER_PROPS}>
        <HomePageSectionHeading
          title="Backend path"
          description="Build a GraphQL API with the server language of your choice."
        />
        <HomePageTutorialGrid
          tutorials={[
            ...data.introDGS.nodes,
            ...data.introHC.nodes,
            ...data.introTS.nodes,
            ...data.introStrawberry.nodes,
          ]}
        />
      </HomePageSection>
      <HomePageSection
        {...HOME_PAGE_CONTAINER_PROPS}
        py="0"
        pb={{ ...HOME_PAGE_PY }}
      >
        <HomePageSectionHeading
          title="Fullstack path"
          description="Build a complete app with TypeScript or JavaScript, from backend to frontend using Apollo libraries."
        />
        <HomePageTutorialGrid
          tutorials={[
            ...data.liftOff.nodes,
            ...data.liftOff2.nodes,
            ...data.liftOff3.nodes,
          ]}
        />
      </HomePageSection>

      <Box
        bg="silver.200"
        _dark={{
          bg: "black.200",
        }}
        sx={HOME_PAGE_CONTAINER_PROPS}
      >
        <HomePageSection>
          <HomePageSectionHeading
            title="Go further with GraphQL Federation"
            description="Take your existing GraphQL API to the next level with a federated graph architecture."
          />
          <HomePageTutorialGrid
            tutorials={[...data.voyage.nodes, ...data.fedCourses.nodes]}
          />
        </HomePageSection>
      </Box>
    </>
  );
}
